












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class AgeLabel extends Vue {
  @Prop({
    default: 0
  })
  public monthsValue!: number;

  @Prop({
    default: 0
  })
  public weeksValue!: number;

  @Prop({
    default: false
  })
  public sigular!: boolean;

  @Prop({
    default: false
  })
  public double!: boolean;

}
